module.exports = __webpack_public_path__ + "media/components/Influencers/FormTags/Select/Occupation/l_shaped-e99a7cc63b54b0d484488c87ef8ec160.svg";